import { useCallback, useEffect, useMemo, useState } from 'react'

import { useLatest } from './useLatest'

/**
 * Позволяет получать css переменные Consta
 * Подписывается на обновление корневого div темизации
 */
export const useCssVariable = <T extends string>(...varNames: readonly T[]): Record<T, string> => {
  const styleSource = useLatest(document.querySelector('div.Theme') ?? document.body)

  const recomputeStyle = useCallback(() => {
    setStyles(window.getComputedStyle(styleSource.current))
  }, [])

  const mutationObserver = useLatest(new MutationObserver(recomputeStyle))
  const [styles, setStyles] = useState<CSSStyleDeclaration | undefined>()

  useEffect(() => {
    recomputeStyle()
  }, [recomputeStyle])

  useEffect(() => {
    const mutationObserverCurrent = mutationObserver.current

    mutationObserverCurrent.observe(styleSource.current, {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false,
    })

    return () => {
      mutationObserverCurrent.disconnect()
    }
  }, [])

  return useMemo(() => {
    return varNames.reduce<Record<T, string>>(
      (acc, varName) => {
        acc[varName] = styles?.getPropertyValue(varName) ?? 'hotpink'
        return acc
      },
      // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter, @typescript-eslint/consistent-type-assertions
      {} as Record<T, string>,
    )
  }, [styles, varNames])
}
